<template>
  <div class="wrapper" id="orderDetails">
    <main class="contentModule">
      <div class="mainContent">
        <div class="theme">
          <div class="title">订单信息</div>
          <div class="titleLetter">ORDER INFORMATION</div>
          <div class="colorBlocks"></div>
        </div>
        <div class="orderDetailsList">
          <div>
            <div class="orderState">
              <span></span>
              <span>订单状态：{{orderData.taxOrderStatusInfo}}</span>
              <span class="taxOrderStatusInfo"></span>
            </div>
            <div class="sum">
              <span></span>
              <span>保费金额：</span>
              <span class="payMoney">{{orderData.payMoney}}元</span>
            </div>
          </div>

          <ul>
            <li><span>订单号：</span><span>{{orderData.orderIdNum}}</span></li>
            <li><span>保单状态：</span><span>{{isInsuredStatusList[$$.isValidObj(orderData.isInsuredStatus) ? orderData.isInsuredStatus.toString() : '']}}</span></li>
            <li><span>保单用途：</span><span>{{orderData.tariffPolicyPurposeCode}}</span></li>
            <li><span>询价保险公司：</span><span>{{findDataName(customsDutiesCode['sellCompany'], orderData.sellInsurePdtId)}}</span></li>
            <li><span>通关海关：</span><span>{{orderData.cleanCustom}}</span></li>
            <li><span>备案海关：</span><span>{{orderData.recordCustom}}</span></li>
            <li><span>保单用途：</span><span>{{findDataName(customsDutiesCode['guaranteeCustomsDutiesCode'], orderData.tariffPolicyPurposeCode)}}</span>
            </li>
            <li><span>保单期限：</span><span>{{findDataName(customsDutiesCode['insurancePeriod'], $$.isValidObj(policyPeriod) ? policyPeriod.toString() : '')}}</span></li>
            <li><span>保单生效日期：</span><span>{{orderData.effectiveDate}}</span></li>
            <li><span>近一年纳税总额（元）：</span><span>{{$$.isValidObj(orderData.lastYearTax) ? get_thousand_num(orderData.lastYearTax) + '元' : '0元'}}</span>
            </li>
            <li><span>投保金额（元）：</span><span>{{$$.isValidObj(orderData.insureAmount) ? get_thousand_num(orderData.insureAmount) + '元' : '0元'}}</span>
            </li>
            <li><span>企业名称：</span><span>{{orderData.policyHolderName}}</span></li>
            <li><span>统一社会信用代码：</span><span>{{orderData.identifyNumber}}</span></li>
            <li><span>企业注册日期：</span><span>{{$$.isValidObj(orderData.brithday) ? orderData.brithday.replace(/^(d{4})(d{2})(d{2})$/, "$1-$2-$3"):''}}</span></li>
            <li><span>营业执照有效期：</span><span>{{orderData.companyCardEndDate}}</span></li>
            <li><span>注册地址：</span><span>{{orderData.registyAddress}}</span></li>
            <li><span>法定代表人：</span><span>{{orderData.corporationName}}</span></li>
            <li><span>证件类型：</span><span>{{findDataName(customsDutiesCode['certificates'],orderData.corporationIdType)}}</span></li>
            <li><span>法定代表证件号：</span><span>{{orderData.corporationIdNum}}</span></li>
            <li><span>企业联系人：</span><span>{{orderData.linkerName}}</span></li>
            <li><span>企业联系人手机号码：</span><span>{{orderData.mobile}}</span></li>
            <li><span>企业联系电话：</span><span>{{orderData.phone}}</span></li>
            <li><span>企业注册所在地：</span><span>{{findDataName(customsDutiesCode['country'],$$.isValidObj(orderData.registeredPlaceCode) ? orderData.registeredPlaceCode.split('-')[0]: '')}}</span>
            </li>
            <li><span>电子邮箱：</span><span>{{orderData.email}}</span></li>
            <li><span>海关注册登记信用级别：</span><span>{{findDataName(customsDutiesCode['creditCode'],orderData.customsCreditCategoryCode)}}</span>
            </li>
            <li><span>企业海关代码：</span><span>{{orderData.customsCompany}}</span></li>
            <li><span>组织机构：</span><span>{{formSelects(customsDutiesCode['companyType'], '1', [orderData.organizationType, orderData.organizationSecondType])}}</span>
            </li>
            <li><span>通讯地址：</span><span>{{orderData.postAddress}}</span></li>
            <li><span>行业：</span><span>{{formSelects(customsDutiesCode['industryCode'], '2', [orderData.industryCategory, orderData.industrySCategory, orderData.industryTCategory, orderData.industryFCategory])}}</span>
            </li>
            <li>
              <span>投保人性质：</span><span>{{findDataName(customsDutiesCode['policyHolderCode'], orderData.applicantNatureCode)}}</span>
            </li>
            <li v-if="$$.isValidObj(orderData.commitmentUrl)"><span>承诺函：</span><span><a :href="orderData.commitmentUrl" target="_blank">查看承诺函</a></span></li>
            <li v-if="$$.isValidObj(orderData.licenseUrl)"><span>营业执照：</span><span><a :href="orderData.licenseUrl" target="_blank">查看营业执照</a></span></li>
            <li v-if="$$.isValidObj(orderData.corporationUrl)"><span>法人身份证：</span><span><a :href="orderData.corporationUrl" target="_blank">查看法人身份证</a></span></li>
            <li v-if="$$.isValidObj(orderData.taxUrl)"><span>关税缴税清单：</span><span><a :href="orderData.taxUrl" target="_blank">查看关税缴税清单</a></span></li>
            <li><span>创建时间：</span><span>{{orderData.createTime}}</span></li>
          </ul>
        </div>
      </div>
      <div class="pageReturns">
        <button :style="buttonSty" @mouseover="buttonOnMouse('background-color: #49A9EE;')"
                @mouseup="buttonOnMouse('background-color: #177FCF;')"
                @mouseout="buttonOnMouse('background-color: #108DE9;')" @click="backManagement()">返回订单管理</button>
      </div>
    </main>
  </div>
</template>

<script>

  import customsDutiesCode from '../../jsonData/customsDutiesCode'

  export default {
    name: "orderDetails",
    data() {
      return {
        id: '',
        orderData: {},
        isInsuredStatusList: {'0': '未生效', '1': '投保成功', '7': '保单生效', '9': '保单失效'},
        customsDutiesCode: customsDutiesCode.customsDutiesCode(),
        policyPeriod: '',
        buttonSty: ''
      }
    },
    methods: {
      getOrder() {
        this.axios.post('/management/tariffInsurance/customsGuaranteeDetail', null, {
          params: {
            id: this.id
          }
        }).then((response) => {
          let data = response.data;
          if (data.success) {
            this.orderData = data.datas;
            let startTime = new Date(this.orderData.effectiveDate),
              endTime = new Date(this.orderData.expireDate);
            this.policyPeriod = (endTime.getFullYear() - startTime.getFullYear()) * 12 + endTime.getMonth() - startTime.getMonth();
            this.policyPeriod = this.policyPeriod < 10 ? '0' + this.policyPeriod : this.policyPeriod
          } else {
            this.$message.error(data.msg);
          }
        });
      },
      get_thousand_num(num) {
        return num.toString().replace(/\d+/, function (n) { // 先提取整数部分
          return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
            return $1 + ",";
          });
        });
      },
      //-- 获取代码数据名称
      findDataName(list, value) {
        for (let i in list) {
          const {code, label} = list[i];
          if (code === value) return label;
        }
      },
      //-- 设置多选下拉的值 type[1：组织机构，2：行业]
      formSelects(list, type, value = []) {
        switch (type) {
          case "1": {
            let listOne = foreach(list, value[0]);
            if ( this.$$.isValidObj(listOne) && !this.$$.isValidObj(listOne.children)) {
              return listOne.name;
            }
            if( this.$$.isValidObj(listOne) && this.$$.isValidObj(listOne.children) ){
              let listTwo = foreach(listOne.children, value[1]);
              return listOne.name + '-' + listTwo.name;
            }
          }
          case "2": {
            let list1 = foreach(list, value[0]);
            let list2 = [];
            if( this.$$.isValidObj(list1) ) list2 = foreach(list1.children, value[1]);
            let list3 = [];
            if( this.$$.isValidObj(list2) ) list3 = foreach(list2.children, value[2]);
            let list4 = [];
            if( this.$$.isValidObj(list3) ) list4 = foreach(list3.children, value[3]);

            if( this.$$.isValidObj(list1) && this.$$.isValidObj(list2) && this.$$.isValidObj(list3) && this.$$.isValidObj(list4) )
              return list1.name + '-' + list2.name + '-' + list3.name + '-' + list4.name;
          }
        }

        function foreach(list, code) {
          for (let i in list) {
            const {value} = list[i];
            if (code === value) return list[i];
          }
        }
      },
      buttonOnMouse(style){
        this.buttonSty = style;
      },
      backManagement(){
        this.$router.push({ name: 'dutyInsuranceOrderManagement'});
      }
    },
    mounted() {
      if (this.$$.isValidObj(this.$route.query.id)) {
        this.id = this.$route.query.id;
        this.getOrder();
      } else {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'dutyInsuranceOrderManagement'});
        });
      }

    }
  }
</script>

<style scoped>

  @import "../../../../static/css/dutyInsurance/orderDetails.css";
</style>



// WEBPACK FOOTER //
// src/components/product/dutyInsurance/orderDetails.vue